<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="11.048" height="10.871" viewBox="0 0 11.048 10.871">
		<path
			id="Path_19228"
			data-name="Path 19228"
			d="M8.333,8.462l.293-.293a2.318,2.318,0,0,1,3.278,0L13.456,9.72a2.318,2.318,0,0,1,0,3.279l-.1.1a2.318,2.318,0,0,1-3.279,0l-.507-.507"
			transform="translate(-3.864 -3.509)"
			fill="none"
			stroke="#515a70"
			stroke-linecap="round"
			stroke-width="1.2"
		/>
		<path
			id="Path_19229"
			data-name="Path 19229"
			d="M7.458,6.975l-.293.293a2.318,2.318,0,0,1-3.279,0L2.336,5.717a2.318,2.318,0,0,1,0-3.278l.1-.1a2.318,2.318,0,0,1,3.278,0l.239.239"
			transform="translate(-1.057 -1.057)"
			fill="none"
			stroke="#515a70"
			stroke-linecap="round"
			stroke-width="1.2"
		/>
	</svg>
</template>

<script>
export default {
	name: 'LinkSvg',
};
</script>

<style scoped lang="scss"></style>
